export const COOKIE_NAME = 'guest-token';
export const COOKIE_NAME_V2 = `${COOKIE_NAME}-v2`;